import { useEffect, useState } from "react";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { setSingleSelect } from "../../../redux/filtersSlice";
import { setCurrentPage } from "../../../redux/productSlice";

// Custom Option Component
const CustomSingleOption = (props) => {
  const { data, isSelected, innerRef, innerProps } = props;

  return (
    <div
      ref={innerRef}
      {...innerProps}
      className="flex items-center gap-2 p-2 cursor-pointer hover:bg-gray-100"
    >
      <input
        type="radio"
        checked={isSelected}
        onChange={() => {}}
        className="form-radio"
      />
      <label className="text-sm">{data?.label}</label>
    </div>
  );
};

// Single-select with radio buttons
const SingleSelect = ({ label, options, filterId, selected }) => {
  const dispatch = useDispatch();
  const drawerOpen = useSelector((state) => state.view.drawer);
  const selectedOptionId =
    useSelector((state) => state.filters.singleSelect[filterId]) ?? selected;

  // Local state to ensure re-renders
  const [localSelected, setLocalSelected] = useState(null);

  // Sync with Redux state
  useEffect(() => {
    const option = options.find((option) => option.value === selectedOptionId);
    setLocalSelected(option || null);
  }, [selectedOptionId, options]);

  const handleChange = (selected) => {
    dispatch(setCurrentPage(0));
    dispatch(setSingleSelect({ filterId, selectedValue: selected }));
  };

  return (
    <div className={`max-w-sm ${drawerOpen ? "w-full" : "md:hidden"}`}>
      <h3 className="font-bold text-sm text-primeColor mb-2 capitalize">
        {label}
      </h3>
      <Select
        options={options}
        value={localSelected}
        onChange={handleChange}
        isMulti={false} // Single select
        components={{ Option: CustomSingleOption }}
        closeMenuOnSelect={true} // Close menu after selecting
        className="react-select-container"
        classNamePrefix="react-select"
        styles={{
          control: (provided) => ({
            ...provided,
            fontSize: "11px",
            height: "35px",
            minHeight: "35px",
            padding: "0 2px",
            alignItems: "center",
          }),
          menu: (provided) => ({
            ...provided,
            fontSize: "12px",
          }),
        }}
      />
    </div>
  );
};

export default SingleSelect;
